import React from "react";
import { ScriptableUi } from "./ScriptableUi";

export const ScriptableUiContext = React.createContext<ScriptableUi<any> | undefined>(undefined);